import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'filter-tag-slider',
  templateUrl: './filter-tag-slider.component.html',
  styleUrls: ['./filter-tag-slider.component.css']
})
export class FilterTagSliderComponent {

  @Input() control: UntypedFormControl;
  @Input() format: string = '';
  @Input() title: string = '';
  @Input() secondaryMaxText: string = '';
  @Input() range: { min: number; max: number; step: number; } = { min: 0, max: 100, step: 1 };
  @Input() defaultValue: Array<number> = [0, 100];
  @Input() plusValue: number = 0;
  @Output() eventReset = new EventEmitter<undefined>();


  constructor() { }


  onClickResetControl(event: MouseEvent): void {
    event.preventDefault();
    this.control.setValue(this.defaultValue);
    this.eventReset.next(undefined);
  }
}
